var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.type,_vm._b({tag:"component",staticClass:"flex items-center justify-center text-sm rounded p-3 focus:outline-none hover:cursor-pointer",class:{
    [_vm.$style['BaseButton--disabled']]: _vm.disabled,
    'bg-sh-primary text-white hover:bg-sh-primary-lighten-5':
      _vm.color === 'primary',
    'bg-white text-grey-500 hover:bg-grey-light': _vm.color === 'white',
    'bg-transparent text-black': _vm.color === 'transparent',
    'bg-white text-sh-primary underline': _vm.color === 'link'
  },on:{"!click":function($event){return _vm.clickHandler.apply(null, arguments)}}},'component',_vm.$props,false),[_c('span',[_vm._t("default")],2),(_vm.icon)?_c('base-icon',{staticClass:"ml-2",attrs:{"name":_vm.icon,"size":"sm"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }